<template>
  <div class="text-xs-center">
    <h1 class="hidden-sm-and-up headline" :class="{ 'pb-3': !subheader }" style="font-family: Signika; font-style: normal; font-weight: 700;">{{header}}</h1>
    <h3 class="hidden-sm-and-up subheading font-weight-light" v-if="subheader">{{subheader}}</h3>
    <h1 class="hidden-xs-only display-3" :class="{ 'pb-3': !subheader }" style="font-family: Signika; font-style: normal; font-weight: 700;">{{header}}</h1>
    <h3 class="hidden-xs-only display-1 font-weight-light" v-if="subheader">{{subheader}}</h3>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    header: String,
    subheader: String
  },
  data() {
    return {}
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Title.vue